import { jsxs as C, jsx as s } from "react/jsx-runtime";
import { useWindowSize as pe, PrimaryButton as ge, FormInput as Ce, toast as u } from "@systemeio/ui";
import { BadRequest as _e } from "@systemeio/util";
import { useState as n, useRef as we, useEffect as ve } from "react";
import { twMerge as Z } from "tailwind-merge";
import { useTranslation as Ne } from "../../i18n.mjs";
import { FileGrid as Ie } from "./components/file-grid.mjs";
import { FileSearch as Re } from "./components/file-search.mjs";
import { useInfiniteDataFiles as xe } from "./hooks/use-data-files.mjs";
import { useFileActions as ye } from "./hooks/use-file-actions.mjs";
import { useFileDetails as be } from "./hooks/use-file-details.mjs";
import { SortDirectionEnum as Se } from "../../enums/pagination-enums.mjs";
import { useFileUploader as Ee } from "../file-uploader/hooks/use-file-uploader.mjs";
import { FileUploaderDropZone as De } from "../file-uploader/components/file-uploader-drop-zone/index.mjs";
import { FileDetails as Be } from "../../components/file-details/index.mjs";
import { ConfirmationModal as L } from "../../components/confirmation-modal/index.mjs";
import { FileUploaderModal as Oe } from "../file-uploader/file-uploader-modal.mjs";
import { getImageAspectRatio as je, areAspectRatiosEqual as ke, getAspectRatioNote as ze } from "../../utils/aspect-ratio.mjs";
import { imageToFile as He } from "../../utils/image-to-file.mjs";
import { convertFileInfoToDataFile as Ge } from "../../utils/convert-file-info-to-data-file.mjs";
import { ImageCropperModal as We } from "../image-cropper/image-cropper-modal.mjs";
import { isImageFile as Ze } from "../../utils/is-image.mjs";
function ct({
  uploadingFromSource: _,
  requiredCropping: F = !0,
  fileUploaderModalProps: o,
  initialSearchFilters: A,
  disabledFileTypeSelect: J,
  disabledFileSourceSelect: K,
  fileSelectorRef: b,
  onSelect: w,
  fileManagerApiType: c
}) {
  var G, W;
  F = !!(F && ((W = (G = o == null ? void 0 : o.imageCropperModalProps) == null ? void 0 : G.imageCropperProps) != null && W.aspectRatio));
  const { t: i } = Ne(), { width: S } = pe(), [v, Q] = n(
    A ?? {
      name: "",
      source: [],
      type: []
    }
  ), [V, X] = n(v), [f, E] = n(), [l, N] = n(), [d, I] = n(), [R, D] = n(""), [a, Y] = n(), x = xe({
    filter: V,
    sortColumn: "createdAt",
    sortDirection: Se.Desc,
    fileManagerApiType: c
  }), { resetAndRefetch: B, deleteItemFromData: $, renameItemFromData: q } = x, { deleteFile: T, downloadFile: U, renameFile: M } = ye(), { data: t, isFetching: P } = be({
    id: f == null ? void 0 : f.id,
    fileManagerApiType: c
  }), ee = async () => {
    l && (await T(l), $(l.id), u.success(i("file_manager.file_deleted_successfully")), N(void 0));
  }, te = async (e) => {
    try {
      await U(e);
    } catch {
    }
  }, [oe, y] = n(), ne = async () => {
    var e;
    if (d)
      try {
        y(void 0), await M({ id: d.id, name: R }), q({ id: d.id, name: R }), u.success(i("file_manager.file_renamed_successfully")), I(void 0);
      } catch (r) {
        if (r instanceof _e)
          y((e = r.errors.fields.name) == null ? void 0 : e.join(" "));
        else
          throw r;
      }
  }, h = we(void 0), [ie, p] = n(!1), re = (e) => {
    var r;
    (r = h.current) == null || r.setWaitingUploadFiles((m) => [...m, { file: e }]), p(!0);
  };
  ve(() => {
    o != null && o.uploaderRef && (o.uploaderRef.current = h.current);
  }, [h.current]), b && (b.current = {
    setFileUploadModalOpen: p
  });
  const { createFileUploader: se } = Ee(c), [ae, O] = n(!1), [ce, j] = n(!1), [le, k] = n(!1), [me, z] = n(), fe = (e) => {
    O(!0), z(e);
  }, H = () => {
    O(!1), z(void 0);
  }, ue = async (e) => {
    try {
      j(!0);
      const m = await se(() => {
      }).upload({
        file: e,
        source: _
      });
      if (!m) throw new Error();
      const g = Ge(m, _);
      w(g), B(), H();
    } catch {
      u.error(i("file_manager.error"));
    } finally {
      j(!1);
    }
  }, Fe = async () => {
    var r, m;
    if (!a) return;
    const e = (m = (r = o == null ? void 0 : o.imageCropperModalProps) == null ? void 0 : r.imageCropperProps) == null ? void 0 : m.aspectRatio;
    if (!F || !Ze(a) || !e || isNaN(e)) {
      w(a);
      return;
    }
    try {
      k(!0);
      const [g, de] = await je(a.path);
      if (ke(de, e)) {
        w(a);
        return;
      }
      u(ze(e));
      const he = await He(g, a.name, a.type);
      fe(he);
    } catch {
      u.error(i("file_manager.error"));
    } finally {
      k(!1);
    }
  };
  return /* @__PURE__ */ C("div", { className: "flex gap-5", children: [
    /* @__PURE__ */ s(
      "div",
      {
        className: Z(
          f ? "w-1/2" : "w-full",
          S < 1024 && f ? "hidden" : "auto"
        ),
        children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ s(
            Re,
            {
              isFetching: x.isFetching,
              values: v,
              disabledFileSourceSelect: K,
              disabledFileTypeSelect: J,
              onChange: Q,
              onSubmit: () => {
                X(v);
              }
            }
          ),
          /* @__PURE__ */ s(
            Ie,
            {
              dataFilesApi: x,
              onDetails: E,
              onSelect: Y,
              specialElementInGrid: /* @__PURE__ */ s(
                De,
                {
                  className: "h-full w-full",
                  dropZoneClassName: "w-full h-full items-center",
                  labelClassName: "text-text-primary",
                  onSelectFile: re
                }
              ),
              ...!(c != null && c.isCommon) && {
                onDelete: N,
                onDownload: te,
                onRename: (e) => {
                  I(e), D(e.name);
                }
              }
            }
          ),
          /* @__PURE__ */ C("div", { className: "sticky bottom-4 flex items-center justify-between sm:relative sm:bottom-0", children: [
            /* @__PURE__ */ C("div", { className: "text-text-tertiary text-sm", children: [
              +!!a,
              " ",
              i("file_manager.file_selector.files_selected")
            ] }),
            /* @__PURE__ */ s(
              ge,
              {
                className: "min-w-14",
                disabled: a === void 0,
                isFetching: le,
                onClick: () => Fe(),
                children: i("file_manager.select")
              }
            )
          ] })
        ] })
      }
    ),
    f && /* @__PURE__ */ s(
      Be,
      {
        className: Z(S < 1024 ? "w-full" : "max-w-[calc(50%-20px)]"),
        fileType: t == null ? void 0 : t.type,
        src: (t == null ? void 0 : t.path) ?? (t == null ? void 0 : t.thumbnail) ?? void 0,
        alt: t == null ? void 0 : t.name,
        name: t == null ? void 0 : t.name,
        size: t == null ? void 0 : t.size,
        onClose: () => E(void 0),
        isFetching: P
      }
    ),
    /* @__PURE__ */ s(
      L,
      {
        opened: !!l,
        onClose: () => N(void 0),
        confirmationText: i("file_manager.file_selector.file_deletion_confirmation_text", {
          file: l == null ? void 0 : l.name
        }),
        onConfirm: () => ee()
      }
    ),
    /* @__PURE__ */ s(
      L,
      {
        opened: !!d,
        onClose: () => {
          I(void 0), y(void 0);
        },
        title: i("file_manager.file_selector.rename_file"),
        confirmButtonCaption: i("file_manager.rename"),
        confirmationContent: /* @__PURE__ */ s(
          Ce,
          {
            label: i("file_manager.file_selector.file_name"),
            placeholder: i("file_manager.file_selector.enter_new_file_name"),
            value: R,
            onChange: (e) => D(e.target.value),
            error: oe
          }
        ),
        onConfirm: () => ne()
      }
    ),
    /* @__PURE__ */ s(
      Oe,
      {
        ...o,
        uploaderRef: h,
        opened: ie,
        source: _,
        showCroppingNote: F,
        onClose: () => p(!1),
        onUploadFinish: () => {
          B(), p(!1);
        },
        fileManagerApiType: c
      }
    ),
    /* @__PURE__ */ s(
      We,
      {
        isFetching: ce,
        imageFile: me,
        opened: ae,
        onClose: H,
        onCrop: ue,
        actionButtonLabel: i("file_manager.file_upload.crop_and_select_file"),
        ...o == null ? void 0 : o.imageCropperModalProps
      }
    )
  ] });
}
export {
  ct as FileSelector
};
